import { RootState } from '../../../applicationStore';
import { ScheduledValueState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getScheduledValueState = (state: RootState): ScheduledValueState =>
  state.scheduledValue;

export const getScheduledValueLoader = createSelector(
  getScheduledValueState,
  (state): boolean => state.loading,
);

export const getScheduledValueData = createSelector(
  getScheduledValueState,
  (state): ScheduledValueState['data'] | null => state?.data || null,
);
